import { useState } from 'react'
import Icon from '@forwardflow/ui/Icons'
import dayjs from 'dayjs'

interface MessageItemProps {
   item: any
}

export const EventItem: React.FC<MessageItemProps> = ({ item }) => {
   const stripHtml = (html: string) => {
      const tmp = document.createElement('DIV')
      tmp.innerHTML = html
      return tmp.textContent || tmp.innerText || ''
   }
   const [isExpanded, setIsExpanded] = useState(false)
   const toggleExpand = () => {
      setIsExpanded(!isExpanded)
   }
   return (
      <div>
         <div className="bg-[#D9D9D9]/10 text-[14px]">
            <div className="flex items-center justify-between px-8 py-3 border-b border-white/20">
               <p>Event - {item?.outcome || ''}</p>
               {dayjs(item?.ts).format('h:mm A, D MMM YYYY')}
            </div>
            <div
               className="flex items-center gap-x-6 px-8 py-4 text-[14px]  justify-between cursor-pointer"
               onClick={toggleExpand}
            >
               <div
                  className={`${
                     isExpanded ? '' : 'line-clamp-1'
                  } transition-all duration-200`}
               >
                  {stripHtml(item?.content)}
               </div>
               <Icon
                  name="arrow-down"
                  className={`${isExpanded ? '-rotate-180' : ''}`}
               />
            </div>
         </div>
      </div>
   )
}
